export { SupabaseStorageManager } from "./supabase";
export type {
  SupabaseStorageConfig,
  DocumentUploadResult,
  DocumentVersion,
} from "./supabase";
